<template>
  <el-timeline :id="content.key" class="content_w_710">
    <el-timeline-item :timestamp="item.text" placement="top" v-for="(item,index) in content.content" :key="index"  >
      <el-card>
        <p v-for="(items,indexs) in item.content" :key="indexs" ref=""
          :style="{
            color: content.textStyle.color || '',
            fontSize: (items.textStyle.fontSize + 'rem') || '',
            textIndent: (items.textStyle.textIndent && typeof items.textStyle.textIndent === 'string') ? items.textStyle.textIndent :
        (items.textStyle.textIndent && typeof items.textStyle.textIndent === 'number') ? (items.textStyle.textIndent + 'rem') : '',
          }"
        >{{ items.text }}</p>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</template>
<script>
/*
封面内容
*/
export default {
  name: "timeline",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
 
}
</script>
<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 40px);
  margin: 0 auto 20px;
}

/deep/.el-timeline-item__timestamp{
  color:#515151 ;
  font-size: 24rem !important;

}
// /deep/.el-timeline-item__node--normal{
//   width: 20rem;
//   height: 20rem;
// }
// /deep/.el-timeline-item__tail{
//   left:9rem;

// }
</style>